module.exports = __webpack_public_path__ + "img/cjj_hd.cdefdcd3.jpg";